// extracted by mini-css-extract-plugin
export default {"drop-container":"DropInput_drop-container__aiPLd","default-cursor":"DropInput_default-cursor__1syb4","drop-img":"DropInput_drop-img__tSpRa"};